export const state = () => ({
  message: '',
  hostname: 'com',
  tests: [],
  features: {}
})

export const actions = {
  setAppMessage({ commit }, payload) {
    commit('setAppMessage', payload)
  },

  clearAppMessage({ commit }) {
    commit('clearAppMessage')
  },

  setTest({ commit }, payload) {
    commit('setTest', payload)
  }
}

export const mutations = {
  setAppMessage(state, error) {
    state.message = error
  },

  clearAppMessage(state) {
    state.message = ''
  },

  setTest(state, payload) {
    state.tests.push(payload)
  },

  setFeatures(state, payload) {
    state.features = JSON.parse(payload)
  },

  setHostname(state, payload) {
    state.hostname = payload
  }
}

export const getters = {
  getTestById: state => testId => state.tests.find(test => test.id === testId),
  getFeature: state => featureName => state.features[featureName],
  getHostname: state => state.hostname
}
